const TRUE_VALUES = new Set(['1', 'true', 'yes', 'on']);

function isTruthy(value) {
  return TRUE_VALUES.has(String(value || '').trim().toLowerCase());
}

function isLocalHost() {
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname;
  return host === 'localhost' || host === '127.0.0.1' || host === '0.0.0.0';
}

export function isLocalSamlBypassEnabled() {
  return isTruthy(process.env.REACT_APP_LOCAL_SAML_BYPASS) && isLocalHost();
}

export function getBypassAdminUser() {
  return {
    _id: process.env.REACT_APP_LOCAL_BYPASS_USER_ID || 'local-dev-admin',
    email: process.env.REACT_APP_LOCAL_BYPASS_EMAIL || 'local-dev@bellhopt.local',
    firstName: process.env.REACT_APP_LOCAL_BYPASS_FIRST_NAME || 'Local',
    lastName: process.env.REACT_APP_LOCAL_BYPASS_LAST_NAME || 'Admin',
    role: process.env.REACT_APP_LOCAL_BYPASS_ROLE || 'admin',
    isAdmin: true,
  };
}

